import React from "react";
import { Link } from "react-router-dom";

export default function FeaturedPost({ post }) {
  return (
    <Link to={`/blog/${post.slug}`} className="group">
      <article className="relative bg-white rounded-lg overflow-hidden border border-primary/30 hover:shadow-xl hover:border-primary transition-all duration-300 h-full">
        {/* Featured Badge */}
        <div className="absolute top-3 right-3 z-10 px-3 py-1 text-12 font-medium text-white bg-gradient-to-r from-primary to-blue-600 rounded-full">
          Featured
        </div>

        {/* Featured Image */}
        {post.featuredImage && (
          <div className="relative overflow-hidden h-64">
            <img
              src={post.featuredImage}
              alt={post.title}
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
            
            {/* Category on image */}
            {post.category && (
              <span className="absolute bottom-3 left-3 px-3 py-1 text-12 font-medium text-white bg-white/20 backdrop-blur-sm rounded-full">
                {post.category.name}
              </span>
            )}
          </div>
        )}

        {/* Content */}
        <div className="p-6">
          <h3 className="text-22 font-medium text-secondary group-hover:text-primary transition-colors mb-3 line-clamp-2">
            {post.title}
          </h3>

          <p className="text-14 text-light-gray line-clamp-2 mb-4">
            {post.excerpt}
          </p>

          {/* Meta */}
          <div className="flex items-center justify-between text-12 text-light-gray pt-4 border-t border-stroke">
            <div className="flex items-center gap-2">
              {post.author?.avatar && (
                <img
                  src={post.author.avatar}
                  alt={post.author.name}
                  className="w-6 h-6 rounded-full"
                />
              )}
              <span className="font-medium">{post.author?.name}</span>
            </div>
            <div className="flex items-center gap-2">
              {post.readTime && <span>{post.readTime} min</span>}
            </div>
          </div>
        </div>
      </article>
    </Link>
  );
}
